import React, { Component } from 'react';
import queryString from 'query-string';
import { Route } from 'react-router';

import { Layout } from './components/Layout';
import { Home } from './components/Home';
import { Codes } from './components/Codes';
import { Campaigns } from './components/Campaigns';
import { Campaign } from './components/Campaign';

import SplashScreen from './components/SplashScreen';

import './custom.css'

class App extends Component {
    render() {
        var path = window.location.pathname;
        var hideMenu = path.indexOf("/campaign/") > -1 || path.indexOf("/c/") > -1;

        var qs = queryString.parse(window.location.search);
        var diags = qs["diags"];

        return (
            <Layout hide={this.props.hide} hideMenu={hideMenu} diags={diags}>
                <Route exact path='/' component={Home} />
                <Route exact path='/code' component={Codes} />
                <Route exact path='/campaign' component={Campaigns} />
                <Route exact path='/campaign/:id' render={(params) => <Campaign id={params.match.params.id} hide={this.props.hide} history={params.history} />} />
                <Route exact path='/c/:id' render={(params) => <Campaign id={params.match.params.id} hide={this.props.hide} history={params.history} />} />
            </Layout>
       );
  }
}

export default SplashScreen(App);